import React from 'react'
import { usePromiseTracker } from 'react-promise-tracker'
import Loader from 'react-loader-spinner'

const LoadingWrapper = ({ area, loaderType = 'ThreeDots', children }) => {
    const { promiseInProgress } = usePromiseTracker({
        area,
    })

    return (
        <>
            {promiseInProgress && (
                <div className="overlay">
                    <Loader type={loaderType} color="#28ff65"></Loader>
                </div>
            )}
            {children}
        </>
    )
}

export default LoadingWrapper
